export default "__VITE_ASSET__CFGS6FNE__"